export default __webpack_public_path__ + "static/home-banner2-mobile-2034d2e3a8696fa11b11c8b9e16a4b91.jpg";